"use client";

import { type PropsWithChildren, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { useSessionStore } from "~/lib/stateManagement/sessionState/sessionStore";
import styles from "./header.module.css";

export const HeaderClient = ({ children }: PropsWithChildren) => {
	const { ref, inView: inViewTop } = useInView({
		initialInView: true,
	});
	const { ref: refBottom, inView: inViewBottom } = useInView({
		initialInView: true,
	});

	const atTop = useSessionStore((store) => store.atTop);
	const setAtTop = useSessionStore((store) => store.setAtTop);
	const scrollDirection = useSessionStore((store) => store.scrollDirection);

	// The two sentinels sit 100px apart (see header.module.css), creating a scroll
	// buffer zone where inViewTop is false while inViewBottom is still true. Each
	// effect below reacts only to its own sentinel's transition - depending on
	// `atTop` here (like the previous handleAtTop/handleAtBottom callbacks did)
	// made the two effects re-trigger each other back and forth inside that zone.
	useEffect(() => {
		if (!inViewTop) setAtTop(false);
	}, [inViewTop, setAtTop]);

	useEffect(() => {
		if (inViewBottom) setAtTop(true);
	}, [inViewBottom, setAtTop]);
	return (
		<>
			<nav
				data-scroll-direction={scrollDirection}
				className={`
        ${styles.header} 
        ${atTop ? "" : styles.scrolled} 
        ${styles.scrollDown} ${scrollDirection === "down" && !atTop ? styles.hidden : ""}
      `}
			>
				{children}
			</nav>
			<div ref={ref} className={`${styles.intersector} ${styles.top}`} />
			<div ref={refBottom} className={`${styles.intersector} ${styles.bottom}`} />
		</>
	);
};
